export type DeadlineSuggestionCountType =
  | 'business_days'
  | 'calendar_days'
  | 'variable';

export type CaseDeadlineSuggestion = {
  suggestedDueDate:
    string |
    null;

  mode:
    'automatic'
    | 'manual_required';

  explanation:
    string;
};

export type CaseDeadlineSuggestionInput = {
  startDate:
    string |
    null |
    undefined;

  daysCount:
    number |
    null |
    undefined;

  countType:
    DeadlineSuggestionCountType;
};

const parseDateOnly =
  (
    value:
      string
  ) => {
    const match =
      /^(\d{4})-(\d{2})-(\d{2})$/.exec(
        value
      );

    if (!match) {
      return null;
    }

    const year =
      Number(
        match[1]
      );

    const month =
      Number(
        match[2]
      );

    const day =
      Number(
        match[3]
      );

    const date =
      new Date(
        Date.UTC(
          year,
          month - 1,
          day
        )
      );

    if (
      date.getUTCFullYear() !==
        year ||
      date.getUTCMonth() !==
        month - 1 ||
      date.getUTCDate() !==
        day
    ) {
      return null;
    }

    return date;
  };

export const suggestCaseDeadlineDueDate =
  (
    input:
      CaseDeadlineSuggestionInput
  ):
    CaseDeadlineSuggestion => {
    const startDate =
      String(
        input.startDate ??
        ''
      ).trim();

    if (!startDate) {
      return {
        suggestedDueDate:
          null,

        mode:
          'manual_required',

        explanation:
          'Informe o marco inicial para obter uma sugestão.',
      };
    }

    const parsedStartDate =
      parseDateOnly(
        startDate
      );

    if (
      !parsedStartDate
    ) {
      return {
        suggestedDueDate:
          null,

        mode:
          'manual_required',

        explanation:
          'O marco inicial informado é inválido.',
      };
    }

    if (
      !Number.isInteger(
        input.daysCount
      ) ||
      Number(
        input.daysCount
      ) <
        0
    ) {
      return {
        suggestedDueDate:
          null,

        mode:
          'manual_required',

        explanation:
          'A regra não possui quantidade fixa de dias para cálculo automático.',
      };
    }

    if (
      input.countType ===
      'business_days'
    ) {
      return {
        suggestedDueDate:
          null,

        mode:
          'manual_required',

        explanation:
          'Prazo em dias úteis exige conferência de feriados e suspensões. Informe manualmente a data final.',
      };
    }

    if (
      input.countType ===
      'variable'
    ) {
      return {
        suggestedDueDate:
          null,

        mode:
          'manual_required',

        explanation:
          'Esta regra possui contagem variável e exige definição manual da data final.',
      };
    }

    const date =
      new Date(
        parsedStartDate.getTime()
      );

    date.setUTCDate(
      date.getUTCDate() +
      Number(
        input.daysCount
      )
    );

    return {
      suggestedDueDate:
        date
          .toISOString()
          .slice(
            0,
            10
          ),

      mode:
        'automatic',

      explanation:
        'Sugestão em dias corridos. A data inicial é tratada como marco zero e a data final deve ser conferida pelo advogado.',
    };
  };